type OnChangeCallback = (total: number) => any
type CounterProvider = 'facebook' | 'twitter' | 'linkedin'

const COUNTER_PROVIDERS = ['facebook', 'twitter', 'linkedin']

export function isSocialShareCountProvider(arg: any): arg is CounterProvider {
  return COUNTER_PROVIDERS.includes(arg)
}

const cache: {[index: string]: SocialShareCounter} = {}

/**
 * The class to hold social shares state.
 * Loads counters when initialized.
 *
 * NOTE: The only working provider now is Facebook.
 * Twitter and LinkedIn had deprecated their APIs. (as per Dec 2018)
 *
 * NOTE: We request counts for `https` URL schemas, but before we had `http` ones.
 * Facebook does not recognize them as same URLs so it makes sense to request
 * for both `https` and `http` - this will provide us with more relevant data.
 * Also, it makes sense to skip base count if total Facebook shares number is bigger then the base.
 *
 */
export default class SocialShareCounter {
  /**
   * @description when multiple counters are rendered on the same page
   * using this function to instanciate them makes sure the only instance will be creted.
   * Hence the state of all counters on the will be synchronized in the UI.
   */
  public static forURL(url: string, count: number) {
    if (!cache[url]) cache[url] = new SocialShareCounter(url, count)
    return cache[url]
  }

  private updateFlags = {
    facebook: false,
    twitter: false,
    linkedin: false,
  }

  private count: number
  private callbacks: OnChangeCallback[] = []

  constructor(url: string, count: number) {
    if (!cache[url]) {
      cache[url] = this
      this.count = count
    }
  }

  public increase(provider: CounterProvider) {
    // Avoid possible errors from JS consumers which lack type safety.
    if (this.updateFlags[provider] === undefined) return
    if (this.updateFlags[provider]) return
    this.count += 1
    this.updateFlags[provider] = true
    this.notify()
  }

  public onChange(callback: OnChangeCallback) {
    this.callbacks.push(callback)
    callback(this.count)
  }

  private notify = () => {
    this.callbacks.forEach((cb) => cb(this.count))
  }
}



// WEBPACK FOOTER //
// ./front/apps/shared/javascripts/social_share_counter.ts